import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';

import { API_DOMAIN } from '../../../../../constants';
import { importOffers } from '../../../../../crud/offer.crud';
import { useDefineUserRole, useFormatMessage } from '../../../../../hooks';
import { getResponseMessage } from '../../../../../utils/utils';
import { IAppState } from '../../../../../store/rootDuck';

export function useGetExample() {
  const { enqueueSnackbar } = useSnackbar();
  const getExample = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/api/shop/import_offers/example`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'example');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      enqueueSnackbar('Ошибка при загрузке файла');
    }
  };

  return { getExample };
}

export function useImportOffer() {
  const { me } = useSelector((store: IAppState) => ({
    me: store.profile.me,
  }));
  const isVendor = useDefineUserRole(me, ['ROLE_VENDOR', 'ROLE_VENDOR_STAFF']);
  const { enqueueSnackbar } = useSnackbar();
  const [loadingUpload, setLoading] = useState(false);
  const [successUpload, setSuccess] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const fm = useFormatMessage();

  const upload = async (data: { file: FormData; company_id?: number }) => {
    setLoading(true);
    importOffers(data)
      .then(res => {
        if (isVendor) {
          setSuccess(true);
          return;
        }
        if (res.data.data.errors && res.data.data.errors.length > 0) {
          setErrors(res.data.data.errors);
        } else {
          setErrors([]);
          setSuccess(true);
        }
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
        }, 200);
      });
  };

  return { upload, loadingUpload, successUpload, errors };
}
